var render = function render(_c,_vm){return _c('svg',_vm._g(_vm._b({staticClass:"svg-icon",class:[_vm.data.staticClass, _vm.props.customClass],attrs:{"aria-hidden":"true"}},'svg',_vm.data.attrs,false),_vm.$listeners),[_c('use',{attrs:{"xlink:href":`#icon-${_vm.props.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }